import { connect } from 'react-redux';

import { getPriceType } from '../../../../browser/fast/fast_filters';
import { IAppState, Dispatch } from '../../../common/state';
import { EPriceType } from '../../../json_query';
import { checkParamType, dealTypeFromJsonQuery, FDealType } from '../../../utils/category';
import { setPriceType } from '../../state/price_type';
import { PriceTypeSelect } from './index';

export const PriceTypeContainer = connect(
  (state: IAppState) => {
    return {
      priceType: getPriceType(state),
      isSaleDealType: checkParamType(dealTypeFromJsonQuery(state.filters.jsonQuery))(FDealType.Sale),
    };
  },
  (dispatch: Dispatch) => ({
    onPriceTypeChanged: (priceType: EPriceType) => {
      dispatch(setPriceType(priceType));
    },
  }),
)(PriceTypeSelect);
